$.fn.hasScrollBar = function() {
    return this.get(0).scrollHeight > this.height();
};

$(function() {
    function viewportScrollBarWidth() {
        return window.innerWidth - $(window).width();
    }
    
    function initializeHeadroom() {
        var navOffsetHeight = (mlnViewport().width >= 992) ? siteHeaderDesktop.height() : siteHeaderMobile.height(),
            navTolerance = 5;
                    
        if (mlnViewport().width >= 768) {
            if (siteHeaderMobile.hasClass('headroom')) {
                siteHeaderMobile.headroom('destroy');
            }

            siteHeaderDesktop.headroom({
                offset: navOffsetHeight,
                tolerance : navTolerance
            });
        } else {
            if (siteHeaderDesktop.hasClass('headroom')) {
                siteHeaderDesktop.headroom('destroy');
            }
            
            siteHeaderMobile.headroom({
                offset: navOffsetHeight,
                tolerance : navTolerance
            });
        }
    }
    
    var $body = $('body');
    var $document = $(document);
    var primaryNavEl = $('#navPrimary');
    var megaMenuEl = $('#megaMenu');
    var surroundEl = $('.l-surround');
    var canvasEl = $('.l-canvas');
    var siteHeaderEl = $('.site-header');
    var scrollBarWidth;
    var docCurrentLoc = 0;
    var docScrollLoc = 0;
    var siteHeaderDesktop = $('.site-header--desktop');
    var siteHeaderMobile = $('.site-header--mobile');
    
    // Initialize mln
    primaryNavEl.multilevelNav({
        'hoverIntent': true,
        'hoverIntentTimeout': 300,
        'childMenuTogglerSymbol': '<i class="fas fa-chevron-right" aria-hidden="true"></i>'
    });
    
    
    // Initialize mln slide over functionality
    primaryNavEl.multilevelSlideOver({
        'slideTitles': false,
        'backButtonMarkup': '<i class="fas fa-chevron-left mr-1" aria-hidden="true"></i>Back'
    });
    
    
    // Mega menu showing adjustments    
    megaMenuEl.on('show.bs.collapse', function() {
        docScrollLoc = $document.scrollTop();
        
        scrollBarWidth = viewportScrollBarWidth();
        
        surroundEl.css('padding-right', scrollBarWidth + 'px');
        
        siteHeaderEl.css('width', 'calc(100% - ' + scrollBarWidth + 'px)');
        
        $body.addClass('js-mega-showing');
                
        if ( $body.hasClass('has-header-fixed') ) {
            canvasEl.css('top', -(docScrollLoc));
        }
        
        currentLoc = docScrollLoc;
        
    }).on('shown.bs.collapse', function() {                
        if ( megaMenuEl.hasScrollBar() ) {
            megaMenuEl.css('width', 'calc(100% + ' + scrollBarWidth + 'px)');
        }
        
        $(this).keyboardTrap();
        
    }).on('hide.bs.collapse', function() {
        $body.removeClass('js-mega-showing');
        
        siteHeaderDesktop.headroom('freeze');
               
        // Scroll canvas to the original canvas position
        if ( $body.hasClass('has-header-fixed') ) {
            $('html').addClass('no-smooth');
            
            canvasEl.css('top', '');
            
            $('html, body').animate({
                scrollTop: currentLoc
            }, 0);
        }
        
        surroundEl.css('padding-right', '');
        
        siteHeaderEl.css('width', '');      
    }).on('hidden.bs.collapse', function() {
        $('html').removeClass('no-smooth');
        siteHeaderDesktop.headroom('unfreeze');
        siteHeaderEl
            .removeClass('headroom--unpinned')
            .addClass('headroom--pinned');
    });
    
    
    // Mega menu keyboarding
    var megaMenuToggleEl = $('.site-header__mega');
    $('.site-header--desktop').on('keydown', function(event) {
        var eventTarget = $(event.target);
        var keyPressed = event.key;
        
        // Escape key
        if (
            keyPressed === "Escape" &&
            eventTarget.hasClass('site-header__toggle--mega') ||
            keyPressed === "Escape" &&
            eventTarget.closest(megaMenuEl).length
        ) {
            megaMenuEl.collapse('hide');
            $('.site-header__toggle--mega').focus();
        }
        
        
        // Focusing out of mega menu closes it
        setTimeout(function(){
            if (
                !$(document.activeElement).closest(megaMenuEl).length &&
                !$(document.activeElement).is('.site-header__toggle--mega')
            ) {
                megaMenuEl.collapse('hide');
            }
        }, 300);
    });
    
    // Close mega menu if clicking off
    $document.on('click', function(e){
        var eventTarget = $(e.target);
        
        if ( !eventTarget.closest('.site-header__mega').length ) {
            megaMenuEl.collapse('hide');
        }
    });

    // Add class to all top level links
    var siteHeaderNavList = $('.site-header__top-level');
    siteHeaderNavList.find('> li > a').each(function () {
        $(this).addClass('mln__top-level-link');
    });

    siteHeaderNavList.find('> li > a:only-child').each(function () {
        $(this).addClass('mln__link-only');
    });

    var topLevelMln = $('.site-header__top-level-mln');
    var siteHeaderRule = $('.site-header__rule');

    topLevelMln.multilevelNav({
        'hoverIntent': true,
        'hoverIntentTimeout': 300,
        'excludeLevel': 2
    });

    if (siteHeaderRule.length) {
        topLevelMln.addClass('site-header__top-level-mln--has-rule');
    }


    
    // Initialize headroom.js
    initializeHeadroom();
    
    // Re initialize headroom after window resize
    $(window).on('widthResizeEnd', function () {
        initializeHeadroom();
    });
    
    // Build and add top button to DOM
    $('<button>')
        .addClass('top-button')
        .attr({
            'type': 'button',
            'aria-label': 'Go to top'
        })
        .appendTo('body');
    
    // Add chevron to top button
    $('<span>')
        .addClass('fas fa-chevron-up')
        .attr('aria-hidden', true)
        .appendTo('.top-button');
    
    // Top button click
    $('.top-button').on('click', function(){
        $('html, body').animate({
            scrollTop: 0
        }, 0);
    }).headroom({
        offset : 2000,
    });

    // Search expando
    $('.site-header__search--expando').each(function(){
        var $expando = $(this);
        var searchToggleBtn = $expando.find('.site-header__search__toggle');
        var searchMenu = $expando.find('.site-header__search__menu');
        var searchInput = $expando.find('[type="text"]');

        searchToggleBtn.on('click', function (e) {
            var $toggler = $(this);

            if ($toggler.attr('aria-expanded') === 'true') {
                $toggler.attr('aria-expanded', 'false');
                searchMenu.removeClass('showing');
            } else if ($toggler.attr('aria-expanded') === 'false') {
                $toggler.attr('aria-expanded', 'true');
                searchMenu.addClass('showing');
                searchInput.focus();
            }
        });
    });
});


// If scrolling add classes to body
window.addEventListener('scroll', function(e) {    
    if ( window.pageYOffset > 0 ) {
        document.body.classList.add('js-is-scrolling');
    } else {
        document.body.classList.remove('js-is-scrolling');
    }
    if ( window.pageYOffset >= 132 ) {
        document.body.classList.add('js-threshold-is-scrolling');
    } else {
        document.body.classList.remove('js-threshold-is-scrolling');
    }
});